import 'view/css/plan.css';

import moment from 'moment';
import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';

import BasePageView from 'view/BasePageView';
import PlanCard from 'component/PlanCard';
import SinglePriceModal from 'component/price/SinglePriceModal';
import BatchPriceModal from 'component/price/BatchPriceModal';
import AnnouncePriceModel from 'component/price/AnnouncePriceModel';

import Protected from 'component/Protected';
import LocationSelect from 'component/dropdown/LocationSelect';

import API from 'service/api';
import Util, { Data } from 'service/util';

class ServicePlanView extends BasePageView
{
  constructor(props)
  {
    super(props);
    this.state = {
      plans: [],
      filter_comp: 'TK',
      filter_dist: '',
      filter_loc: '',
      filter_vhtype: '',
      filter_plan: '',
      sel_dist: '',
      sort_by: '',
      page: 1,
      page_count: 200,
      exporting: false,
    };

    this.title = this.title.bind(this);
    this.showSinglePriceModal = this.showSinglePriceModal.bind(this);
    this.showBatchPriceModal  = this.showBatchPriceModal.bind(this);
    this.setLocation = this.setLocation.bind(this);
  }

  componentDidMount()
  {
    API.getServicePlanList().then(plans => {
      let filter_dist = Data.location[0].srv_dis;
      let filter_loc  = Data.location[0].srv_loc;
      this.setInitiated({plans, filter_dist, filter_loc});
    }).catch(ex => this.setError());
  }


  exportXls()
  {
    this.setState({exporting: true});
    API.exportServicePlan().then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `服務計劃_${ix_date}.xlsx`);
      this.setState({exporting: false});
    });
  }

  showSinglePriceModal(plan)
  {
    this.setState({modal: { mode: 'single', plan }});
  }
  showBatchPriceModal()
  {
    this.setState({modal: { mode: 'batch' }});
  }
  showPriceAnnouncementModal()
  {
    this.setState({modal: { mode: 'announcement' }});
  }
  closeModal()
  {
    this.setState({modal: null});
  }

  setLocation(filter_dist, filter_loc)
  {
    this.setState({ filter_dist, filter_loc });
  }

  sort(key)
  {
    this.setState( (s,p) => { return {sort_by: {key, order: s.sort_by.key===key?-s.sort_by.order:1} }; });
  }

  isNoData = () => 1>this.state.plans.length;
  title = () =><>
    <span className="main-title">基本資料</span> - <span className="sub-title">服務計劃</span>
  </>

  _render()
  {
    let _plans = this.state.plans.filter( p =>
         p.srv_loc == this.state.filter_loc
      && p.srv_dis == this.state.filter_dist
      && p.company == this.state.filter_comp
    );

    if (this.state.filter_vhtype) {
      _plans = _plans.filter(p => p.vh_type == this.state.filter_vhtype)
    }
    if (this.state.filter_plan) {
      _plans = _plans.filter(p => p.cd_plan == this.state.filter_plan)
    }

    if (this.state.sort_by) {
      let s_key   = this.state.sort_by.key;
      let s_order = this.state.sort_by.order;
      if (s_key === 'id') _plans.forEach(l => l.id = `${l.srv_dis}${Util.LPAD(l.srv_loc,6)}`);

      _plans.sort((a,b) => {
        if ( a[s_key] > b[s_key] ) return  s_order;
        if ( a[s_key] < b[s_key] ) return -s_order;
        return 0;
      });
    }

    // page
    let idx_start = (this.state.page-1) * this.state.page_count;
    let idx_end   = idx_start + this.state.page_count;
    _plans = _plans.slice(idx_start, idx_end);

    // selected district
    let sd = Data.location.filter(l =>
      l.srv_dis == this.state.filter_dist && l.srv_loc == this.state.filter_loc
    )[0];

    return (
      <>
        <div className="search-bar box">
          <h4 className="box-head action-panel">
            <span>搜尋</span>
            <div className="button-group">
              <Protected allow={['ADMIN','OPERATOR']}>
                <button className="btn small white" onClick={ e=>this.showBatchPriceModal() }>批次加價</button>
              </Protected>
              <Protected allow={['ADMIN','OPERATOR']}>
                <button className="btn small red" onClick={ e=>this.showPriceAnnouncementModal() }>發送通告</button>
              </Protected>
            </div>
          </h4>
          <div className="box-body">
            <div className="action-panel">
              <div>
                <label className="search-field">
                  <span>公司</span>
                  <select id="f-company" value={ this.state.filter_comp }
                          onChange={ e => this.setState({filter_comp: e.target.value}) }>
                    { Data.company.map(com =>
                      <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
                    )}
                  </select>
                </label>
                <LocationSelect labelClass="search-field" titleComponent="span"
                  district={this.props.filter_dist}
                  location={this.props.filter_loc}
                  onUpdate={this.setLocation}
                />
                <label className="search-field">
                  <span>車輛總類</span>
                  <select id="f-vhtype" value={ this.state.filter_vhtype }
                        onChange={ e => this.setState({filter_vhtype: e.target.value}) }>
                      <option value="">全部</option>
                    { Data.vtype.map(t =>
                      <option key={`vh-${t.id}`} value={t.id}>{t.id} - {t.desc}</option>
                    )}
                  </select>
                </label>
                <label className="search-field">
                  <span>計劃</span>
                  <select id="f-plan" value={ this.state.filter_plan }
                        onChange={ e => this.setState({filter_plan: e.target.value}) }>
                    <option value="">全部</option>
                    { Data.plan.map(p =>
                      <option key={`plan-${p}`} value={p}>{p}</option>
                    )}
                  </select>
                </label>
              </div>
              <div>
                <Protected allow={['ADMIN','OPERATOR','VIEWER_SU']}>
                  <button className="btn dark-green btn-export" disabled={this.state.exporting}
                    onClick={e=>this.exportXls()}>
                    <FontAwesomeIcon icon={faFileExcel} />
                    <span> 匯出</span>
                  </button>
                </Protected>
              </div>
            </div>
          </div>
        </div>
        <h2>
          <span className="s-company">[{ Util.getCompanyName(this.state.filter_comp) }] </span>
          <span className="s-dis">{ Util.getDistrictName(this.state.filter_dist) }</span>
          <span className="s-loc">{ `${sd.srv_dis}${sd.srv_loc} - ${sd.name_zh} ${sd.name_en}`.trim() }</span>
        </h2>
        <div className="plans">
          { _plans.map(p =>
            <PlanCard key={ `${p.srv_dis}${p.srv_loc}-${p.cd_plan}${p.vh_type}` }
                      plan={p} callDetail={this.showSinglePriceModal}/>
          )}
        </div>
        { this.renderModal() }
      </>
    );
  } // render()

  renderModal()
  {
    const M = this.state.modal;
    if (!M) return;

    let modalComponent = (() => {
      switch (M.mode)
      {
        case 'single': return <SinglePriceModal closeModal={this.closeModal} plan={M.plan} />;
        case 'batch':  return <BatchPriceModal  closeModal={this.closeModal} />;
        case 'announcement': return <AnnouncePriceModel closeModal={this.closeModal} />;
        default: throw 'invalid mode';
      }
    })();

    let modalTitle = (() => {
      switch (M.mode)
      {
        case 'single': return '調整單一價格';
        case 'batch':  return '批次調整價格';
        case 'announcement': return '發送價格變動通告';
        default: throw 'invalid mode';
      }
    })();

    return (
      <div className="modal">
        <div className="modal-box">
          <h2 className="modal-head">{modalTitle}</h2>
          <div className="modal-body">
            { modalComponent }
            <div>
              <button type="button" className="btn grey" onClick={e=>this.closeModal()}>關閉</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

} // end class

export default ServicePlanView;